import ObjectStatus from '../enums/static/ObjectStatus';
import {DynamicParametersType} from '../dynamicParameters/dynamicParameters.enums';
import {
  RemoteAiContentTextSpec,
  RemoteAiContentImageSpec,
  RemoteAiContentVideoSpec,
} from './aiContentProject.types';

export enum AiContentItemOutputStatus {
  Initial = 0,
  GeneratingPrompts = 1,
  PromptsGenerated = 2,
  GeneratingAssets = 3,
  AssetsGenerated = 4,
}

export interface RemoteAiContentGeneratedAsset {
  assetType: DynamicParametersType;
  prompt?: string | null;
  promptSummaryForUI?: string | null;//(limited to 30 words)
  reasoning?: string | null;//LLM's reasoning for how/why this prompt or text value was created
  promptError?: string | null;//Error message if prompt generation failed for this asset
  value?: string | null;
  textSpec?: RemoteAiContentTextSpec | null;
  imageSpec?: RemoteAiContentImageSpec | null;
  videoSpec?: RemoteAiContentVideoSpec | null;
}

export interface RemoteAiContentItemOutputForSingleAdSize {
  adSize?: string | null;
  assets?: Record<string, RemoteAiContentGeneratedAsset> | null;
  status: AiContentItemOutputStatus;
  errorMessage?: string | null;
}

export interface RemoteAiContentItem {
  id: number;
  name: string;
  projectId: number;
  clientId: number;
  status: ObjectStatus;
  inputValues: Record<string, unknown>;
  outputs: RemoteAiContentItemOutputForSingleAdSize[];
}

export interface CreateAiContentItemRequest {
  name: string;
  projectId: number;
  inputValues: Record<string, unknown>;
}

export interface CreateMultipleAiContentItemsRequest {
  items: CreateAiContentItemRequest[];
}

export interface UpdateAiContentItemRequest {
  name?: string | null;
  inputValues?: Record<string, unknown | null> | null;
  outputs?: RemoteAiContentItemOutputForSingleAdSize[] | null;
}

export interface GeneratePromptsRequest {
  itemIds: number[];
}

export interface GenerateAssetsRequest {
  itemIds: number[];
  adSizes?: string[] | null;
  assetKeys?: string[] | null;
}

export interface UpdatePromptsRequest {
  itemIds: number[];
  adSizes: string[];
  updatePrompt: string;
}